// import styles from "./SpiderScheduleForm.module.css"
import { Form, Col, Row } from "react-bootstrap";
import Select from "react-select";
import { daysOfWeek } from "../../../../../utilities/functions";
// import AGTable from "../../../components/AGTable/AGTable";
import { Tooltip } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';

const SearchCrawlerSchedulerAddSchedule = (props) => {
    const scheduleObj = props.scheduleObj;
    const setScheduleObj = props.setScheduleObj;


    return (
        <div style={{overflow: 'visible'}}>

            <Form>
                <Form.Group as={Row} className="mb-3  d-flex align-items-center">
                        <Form.Label column sm="2">
                            Day of Week:
                        </Form.Label>
                        <Col sm="4">
                            <Select 
                                isMulti
                                menuPortalTarget={document.body} // render dropdown at body level
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                }}
                                value={scheduleObj?.dayOfWeek} 
                                options={[
                                    {
                                        label: "Every day",
                                        value: "Every day"
                                    },
                                    ...daysOfWeek.map((day) => {
                                        return {
                                            label: day,
                                            value: day
                                        }
                                    })
                                ]}
                                onChange={(e) => {
                                    if (scheduleObj?.dayOfWeek?.length < e.length){
                                        // Added new item
                                        const newItem = e.find(n => !scheduleObj?.dayOfWeek.some(o => o.value === n.value));
                                        if (newItem.value === "Every day"){
                                            // New item is every day
                                            setScheduleObj((prev) => ({
                                                ...prev,
                                                dayOfWeek: [newItem]
                                            }));
                                        } else if (e.some(obj => obj.value === "Every day")) {
                                            // Every day in list but new item is different
                                            const filteredItems = e.filter(obj => obj.value !== "Every day");
                                            setScheduleObj((prev) => ({
                                                ...prev,
                                                dayOfWeek: filteredItems,
                                                day: [{
                                                    value: "Every day",
                                                    label: "Every day"
                                                }]
                                            }));
                                        } else {
                                            // Every day is not in list and new item is also not every day
                                            setScheduleObj((prev) => ({
                                                ...prev,
                                                dayOfWeek: e
                                            }));
                                        }
                                    } else {
                                        // Removed item
                                        if (e.length > 0){
                                            setScheduleObj((prev) => ({
                                                ...prev,
                                                dayOfWeek: e
                                            }));
                                        } else {
                                            setScheduleObj((prev) => ({
                                                ...prev,
                                                dayOfWeek: [{
                                                    value: "Every day",
                                                    label: "Every day"
                                                }]
                                            }));
                                        }
                                    }
                                }}
                            />
                        </Col>
                        <Form.Label column sm="2">
                            Day of Month:
                        </Form.Label>
                        <Col sm="4">
                            <Select
                                isMulti
                                menuPortalTarget={document.body} // render dropdown at body level
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                }}
                                value={scheduleObj?.day}
                                options={[
                                    {
                                        label: "Every day",
                                        value: "Every day"
                                    },
                                    ...Array.from({ length: 31 }, (_, i) => ({
                                        value: i + 1,
                                        label: (i + 1).toString(),
                                    }))
                                ]}
                                onChange={(e) => {
                                    if (scheduleObj?.day?.length < e.length){
                                        // Added new item
                                        const newItem = e.find(n => !scheduleObj?.day.some(o => o.value === n.value));
                                        if (newItem.value === "Every day"){
                                            // New item is every day
                                            setScheduleObj((prev) => ({
                                                ...prev,
                                                day: [newItem]
                                            }));
                                        } else if ([...e].some(obj => obj.value === "Every day")) {
                                            // Every day in list but new item is different
                                            const filteredItems = e.filter(obj => obj.value !== "Every day");
                                            setScheduleObj((prev) => ({
                                                ...prev,
                                                day: filteredItems,
                                                dayOfWeek: [{
                                                    value: "Every day",
                                                    label: "Every day"
                                                }]
                                            }));
                                        } else {
                                            // Every day is not in list and new item is also not every day
                                            setScheduleObj((prev) => ({
                                                ...prev,
                                                day: e
                                            }));
                                        }
                                    } else {
                                        // Removed item
                                        if (e.length > 0){
                                            setScheduleObj((prev) => ({
                                                ...prev,
                                                day: e
                                            }));
                                        } else {
                                            setScheduleObj((prev) => ({
                                                ...prev,
                                                day: [{
                                                    value: "Every day",
                                                    label: "Every day"
                                                }]
                                            }));
                                        }
                                    }
                                }}
                            />
                        </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-3">
                        <Form.Label column sm="2">
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <span>Hour:</span>
                                <Tooltip title="Time in Sydney, Australia">
                                    <span>
                                        <InfoIcon fontSize="small" style={{ cursor: "default", color: "#666" }} />
                                    </span>
                                </Tooltip>
                            </div>
                        </Form.Label>
                        <Col sm="4">
                            <Select 
                                menuPortalTarget={document.body} // render dropdown at body level
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                }}
                                value={{value: scheduleObj?.hour, label: scheduleObj?.hour}} 
                                options={[
                                    ...Array.from({ length: 24 }, (_, i) => ({
                                        value: i < 10 ? `0${i}:00` : `${i}:00`,
                                        label: i < 10 ? `0${i}:00` : `${i}:00`,
                                    }))
                                ]}
                                onChange={(e) => {
                                    setScheduleObj((prev) => ({
                                        ...prev,
                                        hour: e.value
                                    }))
                                }}
                                />
                        </Col>
                        <Form.Label column sm="2">
                            Minute:
                        </Form.Label>
                        <Col sm="4">
                            <Select 
                                menuPortalTarget={document.body} // render dropdown at body level
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                }}
                                value={{value: scheduleObj?.minute, label: scheduleObj?.minute}} 
                                options={[
                                    ...Array.from({ length: 60 }, (_, i) => ({
                                        value: i < 10 ? `0${i}` : `${i}`,
                                        label: i < 10 ? `0${i}` : `${i}`,
                                    }))
                                ]}
                                onChange={(e) => {
                                    setScheduleObj((prev) => ({
                                        ...prev,
                                        minute: e.value
                                    }))
                                }}
                            />                      
                        </Col>
                </Form.Group>
            </Form>
        </div>
      );    
};

export default SearchCrawlerSchedulerAddSchedule;